fx.ns("models", class PageLayoutComponent extends fx.Model {

	constructor(data)
	{
		super(data);
	}

	 // set here defaults value that will be used when creating new model
	 get defaults()
	 {
		return {    page_layout_id : 0,
					component_type : '',
					content : '',
					x : 0,
					y : 0,
					width : 0,
					height : 0,
					font_size : 12,
					font_family : 1,
					text_color : '#000000',
					text_style : '',
					bgcolor : '',
					level : 0,
					content_type : '',
					borderid : 0,
					align : 'left',
					rotation : 0,
					effectName : '',
					photomask : '',
					luminosity : '',
					contrast : '',
					saturation : '',
					isdouble : 0,
					editable : 1
				 };
	 }



	
	
});